import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("주문/결제하기")
const _hoisted_3 = {
  id: "content",
  class: "content"
}
const _hoisted_4 = { class: "payment_order_charge" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "charge_order_tit" }, [
  /*#__PURE__*/_createVNode("h2", { class: "tit" }, "충전금")
], -1)
const _hoisted_6 = { class: "charge_card_area" }
const _hoisted_7 = { class: "total_area" }
const _hoisted_8 = /*#__PURE__*/_createVNode("strong", { class: "total_title" }, "총 사용 금액 :", -1)
const _hoisted_9 = { class: "total_price" }
const _hoisted_10 = { class: "num" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("원 ")
const _hoisted_12 = { class: "charge_card_list" }
const _hoisted_13 = { class: "card_imag_area" }
const _hoisted_14 = { class: "card_txt_area" }
const _hoisted_15 = { class: "card_num" }
const _hoisted_16 = { class: "card_amount" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "card_click_area" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "card_click"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "blind" }, "선택")
  ])
], -1)
const _hoisted_18 = { class: "btn_area_wrap" }
const _hoisted_19 = { class: "btn_area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("span", _hoisted_9, [
              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.commaTotalUseAmount), 1),
              _hoisted_11
            ])
          ]),
          _createVNode("ul", _hoisted_12, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chargeCards, (chargeCard, index) => {
              return (_openBlock(), _createBlock("li", {
                class: ["charge_card", {'active': chargeCard.selected}],
                key: chargeCard.cardNo,
                onClick: _withModifiers(($event: any) => (_ctx.toggleChargeCardSelection(index)), ["prevent"])
              }, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("img", {
                    src: `https://image.toast.com/aaaaays/membershipasp/53e6b6d1ec894a3c8831461476f1f3a5.jpg`,
                    alt: "카드"
                  }, null, 8, ["src"])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("span", _hoisted_15, _toDisplayString(chargeCard.cardNo), 1),
                  _createVNode("span", _hoisted_16, _toDisplayString(chargeCard.displayRestPoint), 1)
                ]),
                _hoisted_17
              ], 10, ["onClick"]))
            }), 128))
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _createVNode("button", {
              type: "button",
              class: "btn btn_default",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearChargeCard && _ctx.clearChargeCard(...args)))
            }, "사용 안함"),
            _createVNode("button", {
              type: "button",
              class: "btn btn_full",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.applyChargeCard && _ctx.applyChargeCard(...args)))
            }, "사용하기")
          ])
        ])
      ])
    ])
  ], 2))
}